import { render, staticRenderFns } from "./RunDatabaseScripts.vue?vue&type=template&id=8c855eec"
import script from "./RunDatabaseScripts.vue?vue&type=script&lang=js"
export * from "./RunDatabaseScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports